export const EducationController = {
    index(): void {},
    show(): void {},
};
